import axios from 'axios';
import { getAutomateApiUrl } from '../automate/apiBase';

function authUrl(path) {
  return `${getAutomateApiUrl()}${path}`;
}

export function loginRequest(identifier, password) {
  return axios.post(authUrl('/auth/login'), { identifier, password });
}

export function registerRequest(body) {
  return axios.post(authUrl('/auth/register'), body);
}

export function forgotPasswordRequest(email) {
  return axios.post(authUrl('/auth/forgot-password'), { email });
}

export function resetPasswordRequest(body) {
  return axios.post(authUrl('/auth/reset-password'), body);
}

export function verifyEmailRequest(token) {
  return axios.get(authUrl(`/auth/verify-email/${encodeURIComponent(token)}`));
}

export function microsoftSsoRequest(body) {
  return axios.post(authUrl('/auth/microsoft-sso'), body);
}

export function googleSsoRequest(body) {
  return axios.post(authUrl('/auth/google-sso'), body);
}

export function apiMessage(err, fallback) {
  return err?.response?.data?.message || fallback;
}
